import { useState } from 'react';

import { Stack } from '@lyearn/ui';
import Breadcrumbs from '@/components/Breadcrumbs';
import { DeviceSwitcher } from '@/components/DevicePreview';
import PreviewLabel from '@/components/EditorViewer/PreviewLabel';
import usePreviewLabel from '@/components/EditorViewer/PreviewLabel/usePreviewLabel';
import NavigateBack from '@/components/NavigateBack';
import usePageLayout from '@/components/PageLayout/usePageLayout';
import routes from '@/pages/corporate/routes';
import { useAdminRoute } from '@/pages/corporate/routes/hooks/useAdminRoutes';

import { breadcrumbLabel, headerStyles } from './styles';
import { ILearningContent } from './types';

const usePreviewHeader = ({ content }: { content: Partial<ILearningContent> }) => {
  const [selectedDevice, setSelectedDevice] = useState<string>();

  const { previewId, setPreviewId } = usePreviewLabel(
    content?.rootBlockId,
    content?.status,
    content?.versionConfigs,
  );
  const isAdminRoute = useAdminRoute();

  const backLink = isAdminRoute ? routes.LearningContent() : undefined;

  usePageLayout({
    title: content?.name,
    className: headerStyles,
    showNavigationTabs: false,
    LeftNode: (
      <Stack alignItems="center" gapX={12}>
        <NavigateBack to={backLink} />
        <Breadcrumbs
          backLink={backLink}
          breadcrumbs={[
            {
              label: content?.name ?? '',
              overrides: { Typography: { className: `truncate ${breadcrumbLabel}` } },
            },
          ]}
          className="p-0 me-4"
        />
        <PreviewLabel
          previewId={previewId}
          setPreviewId={setPreviewId}
          status={content?.status}
          versionConfigs={content?.versionConfigs!}
        />
      </Stack>
    ),
    CenterNode: (
      <Stack className="absolute top-0 -translate-x-1/2 pt-12 start-1/2 rtl:translate-x-1/2">
        <DeviceSwitcher selectedDevice={selectedDevice} setSelectDevice={setSelectedDevice} />
      </Stack>
    ),
    RightNode: null,
  });

  return { previewId, selectedDevice };
};

export type { ILearningContent };
export default usePreviewHeader;
